import { BankAccounts } from './payload/BankAccounts';
import { Billing } from './payload/Billing';
import { BusinessInformation } from './payload/BusinessInformation';
import { BusinessSize } from './payload/BusinessSize';
import { Collateral } from './payload/Collateral';
import { ContractEntity } from './payload/ContractEntity';
import { ContractFlowMarket } from './payload/ContractFlowMarket';
import { ContractOnboardingType } from './payload/ContractOnboardingType';
import { InStores } from './payload/InStores';
import { MerchantId } from './payload/MerchantId';
import { MerchantPortalAccountEmail } from './payload/MerchantPortalAccountEmail';
import { MerchantPortalAccountRole } from './payload/MerchantPortalAccountRole';
import { OnboardingMetadata } from './payload/OnboardingMetadata';
import { PaymentProduct } from './payload/PaymentProduct';
import { PlatformAccount } from './payload/PlatformAccount';
import { SensitiveGoods } from './payload/SensitiveGoods';
import { SourceIdentifier } from './payload/SourceIdentifier';
import { TemplateId } from './payload/TemplateId';
import { UnderwritingInquiryEmail } from './payload/UnderwritingInquiryEmail';
export const Fields = {
    bank_accounts: BankAccounts,
    billing: Billing,
    business_information: BusinessInformation,
    business_size: BusinessSize,
    collateral: Collateral,
    contract_entity: ContractEntity,
    contract_flow_market: ContractFlowMarket,
    contract_onboarding_type: ContractOnboardingType,
    in_stores: InStores,
    merchant_id: MerchantId,
    merchant_portal_account_email: MerchantPortalAccountEmail,
    merchant_portal_account_role: MerchantPortalAccountRole,
    onboarding_metadata: OnboardingMetadata,
    payment_product: PaymentProduct,
    platform_account: PlatformAccount,
    sensitive_goods: SensitiveGoods,
    source_identifier: SourceIdentifier,
    template_id: TemplateId,
    underwriting_inquiry_email: UnderwritingInquiryEmail,
};
